
import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexTenants from "./tenants/IndexTenants";
import Dashboard from "./dashboard/Dashboard";
import IndexServers from "./servers/IndexServer";
import ProfileForm from "../modules/userManagement/auth/components/ProfileForm";


const ModuleRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={ <Dashboard /> } />
      <Route index path="/dashboard" element={ <Dashboard /> } />
      <Route index path="/servers" element={ <IndexServers /> } />
      <Route path="/profile" element={ <ProfileForm /> } />
      <Route path="/tenants" element={ <IndexTenants /> } />
    </Routes>
  )

}

export default ModuleRoutes;
